export default {
  MENTION: /@\[(.+?)\]\([0-9]+\)/gi,
  COMMENT_URL_HASH: /#comment-(\d+)-?(\d+)?/i,
  CONTENT: /lesson|resource|path/i,
  ASSIGNEES: /user|group/i,
  EDIT_TRAILING_PATH: /\/edit/i,
  PATH_MODES_TRAILING_URL: /\/?(view|reporting|edit)?$/i,
  // Kanji, hiragana, and katakana
  JAPANESE_CHARACTERS: /[\u4E00-\u9FBF]|[\u3040-\u309F]|[\u30A0-\u30FF]/,
};
